// Runtime configuration (environment-driven). The backend exposes the v1 API
// under /api/v1; the SPA reads its base URL from REACT_APP_API_BASE_URL.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001/api/v1';
